import {HttpMethod} from '@/constants/httpMethod';
import {IKycUploadFileRequest} from '@/dataSource/src/api/kyc/entities';
import logError from '@/utils/errors/logError';

export const uploadFileToS3 = async (
  request: IKycUploadFileRequest,
  presignedUrl: string,
  signal?: AbortSignal,
): Promise<void> => {
  try {
    const response = await fetch(presignedUrl, {
      method: HttpMethod.PUT,
      body: request.file,
      headers: {
        'x-amz-meta-origin': 'user',
        'x-amz-meta-uuid': request.userId,
        'x-amz-meta-document-type': request.document.document_type,
        'Content-MD5': request.document.content_md5,
        'Content-Type': request.document.content_type,
      },
      signal: signal,
    });

    if (!response.ok) {
      throw new Error(`Failed to upload file. Status: ${response.status}`);
    }
  } catch (error) {
    logError(error, {
      customTitle: 'KYC - Error uploading file to S3',
      fileName: 's3.ts',
      functionName: 'uploadFileToS3',
      data: {
        userId: request.userId,
        document: request.document,
        file: {
          name: request.file.name,
          size: request.file.size,
          type: request.file.type,
        },
      },
    });
    throw error;
  }
};
